import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { COLORS } from '../../assets/js/constants';
import { Bar, Description, ProgressBar, Title, Wrapper } from './styled';

class SolidProgressBar extends PureComponent {
    render() {

        const { title, description, width, borderRadius, color, background, progress, smooth = true, animationDuration = 1 } = this.props;

        return (
            <Wrapper>
                { title ? <Title data-test={'title'}>{title}</Title> : null }
                <ProgressBar
                    width={width}
                    borderRadius={borderRadius}
                    color={color}
                    background={background}
                    progress={progress}
                    data-test={'progressBar'}
                ><Bar
                    style={{ width: `${100 * progress}%` }}
                    color={color}
                    borderRadius={borderRadius}
                    smooth={smooth}
                    animationDuration={animationDuration}
                    data-test={'bar'}
                /></ProgressBar>
                { description ? <Description data-test={'description'}>{description}</Description> : null }
            </Wrapper>
        );
    }
}

SolidProgressBar.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    width: PropTypes.number,
    borderRadius: PropTypes.number,
    color: PropTypes.string,
    background: PropTypes.string,
    progress: PropTypes.number,
};


SolidProgressBar.defaultProps = {
    title: '',
    description: '',
    width: 2,
    borderRadius: 0,
    color: COLORS.lightGreen,
    background: COLORS.grey,
    progress: 0,
};

export default SolidProgressBar;
